export const MIN_MEASURABLE_BURST_LENGTH = 2;

export type WedgeBurstToken = symbol;

export type WedgeBurstKeyEvent = Pick<KeyboardEvent, "altKey" | "ctrlKey" | "key" | "metaKey">;

export const isWedgeBurstCharacter = (event: WedgeBurstKeyEvent): boolean =>
	event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;

export const averageCharIntervalMs = (
	charCount: number,
	burstStartAt: number | null,
	lastCharAt: number | null
): number | null => {
	if (charCount < MIN_MEASURABLE_BURST_LENGTH || burstStartAt === null || lastCharAt === null) return null;
	return (lastCharAt - burstStartAt) / (charCount - 1);
};

export const arrivedAtScannerSpeed = (avgCharIntervalMs: number | null, maxCharIntervalMs: number): boolean =>
	avgCharIntervalMs !== null && avgCharIntervalMs <= maxCharIntervalMs;

const burstsInFlight = new Set<WedgeBurstToken>();

export const setWedgeBurstInFlight = (token: WedgeBurstToken, inFlight: boolean): void => {
	if (inFlight) burstsInFlight.add(token);
	else burstsInFlight.delete(token);
};

const isWedgeBurstInFlight = (): boolean => burstsInFlight.size > 0;

export default isWedgeBurstInFlight;
